import BrainboxPort from '../lib/brainbox_port.js'

const ThemeManager = {
  mounted () {
    // Apply initial theme from URL parameter or system preference
    const initialTheme = this.getInitialTheme()
    this.applyTheme(initialTheme)

    // Store bound functions as instance properties
    this.boundHandlePortConnected = this.handleWaveboxConnected.bind(this)
    this.boundHandleThemeChanged = this.handleWaveboxThemeChanged.bind(this)

    // Listen for Wavebox port connection and theme changes
    BrainboxPort.on('port-connected', this.boundHandlePortConnected)
    BrainboxPort.on('theme_changed', this.boundHandleThemeChanged)

    // Listen for system theme changes as fallback
    this.setupSystemThemeListener()
  },

  getInitialTheme () {
    // First, check URL parameter from Wavebox
    const urlParams = new URLSearchParams(window.location.search)
    const colorParam = urlParams.get('color')

    if (colorParam) {
      return colorParam.toLowerCase() === 'dark' ? 'dark' : 'light'
    }

    // Fallback to system preference
    return this.getSystemTheme()
  },

  getSystemTheme () {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark'
    }
    return 'light'
  },

  handleWaveboxConnected (data) {
    // Apply theme from Wavebox connection data
    if (data && data.isDark !== undefined) {
      const theme = data.isDark ? 'dark' : 'light'
      this.applyTheme(theme)
    }
  },

  handleWaveboxThemeChanged (data) {
    // Apply theme from Wavebox theme_changed event
    if (data && data.isDark !== undefined) {
      const theme = data.isDark ? 'dark' : 'light'
      this.applyTheme(theme)
    }
  },

  setupSystemThemeListener () {
    // Listen for system theme changes as fallback
    if (window.matchMedia) {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

      const listener = (e) => {
        // Only apply system theme if we haven't received Wavebox theme
        if (!this.hasWaveboxTheme()) {
          const theme = e.matches ? 'dark' : 'light'
          this.applyTheme(theme)
        }
      }

      // Modern browsers
      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', listener)
      } else {
        // Fallback for older browsers
        mediaQuery.addListener(listener)
      }
    }
  },

  hasWaveboxTheme () {
    // Check if we have a Wavebox color parameter or if port is connected
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.has('color') || BrainboxPort.isConnected
  },

  applyTheme (theme) {
    const html = document.documentElement
    html.setAttribute('data-theme', theme)

    // Also toggle dark class for Tailwind dark mode
    if (theme === 'dark') {
      html.classList.add('dark')
    } else {
      html.classList.remove('dark')
    }
  },

  destroyed () {
    // Clean up listeners using stored bound functions
    BrainboxPort.off('port-connected', this.boundHandlePortConnected)
    BrainboxPort.off('theme_changed', this.boundHandleThemeChanged)
  }
}

export default ThemeManager
